import * as z from 'zod';

import { PayoffId } from '../BrandedIds';
import { zodJSInstantDate } from '../dates/BrandedDate';
import { zodBrandedUuid } from '../utils/Zod';
import {
  LoanStatusActive,
  LoanStatusArchived,
  LoanStatusLiquidated,
  LoanStatusPendingActivation,
  LoanStatusPendingTransfer,
  LoanStatusPreActive,
  LoanStatusReo,
  LoanStatusTransferred,
} from './LoanStatus';

const LoanStatusHistoryBase = z.object({
  changedAt: zodJSInstantDate,
});

const LoanStatusHistoryPendingActivation = LoanStatusHistoryBase.extend({
  status: LoanStatusPendingActivation,
});

const LoanStatusHistoryPreActive = LoanStatusHistoryBase.extend({
  status: LoanStatusPreActive,
});

const LoanStatusHistoryActive = LoanStatusHistoryBase.extend({
  status: LoanStatusActive,
});

const LoanStatusHistoryArchived = LoanStatusHistoryBase.extend({
  status: LoanStatusArchived,
});

const LoanStatusHistoryPendingTransfer = LoanStatusHistoryBase.extend({
  status: LoanStatusPendingTransfer,
});

const LoanStatusHistoryTransferred = LoanStatusHistoryBase.extend({
  status: LoanStatusTransferred,
});

const LoanStatusHistoryPaidOff = LoanStatusHistoryBase.extend({
  status: z.literal('paidOff'),
  payoffId: zodBrandedUuid<PayoffId>(),
});

const LoanStatusHistoryPaidOffUntracked = LoanStatusHistoryBase.extend({
  status: z.literal('paidOffUntracked'),
});

const LoanStatusHistoryReo = LoanStatusHistoryBase.extend({
  status: LoanStatusReo,
});

const LoanStatusHistoryLiquidated = LoanStatusHistoryBase.extend({
  status: LoanStatusLiquidated,
});

export const LoanStatusHistoryEntry = z.discriminatedUnion('status', [
  LoanStatusHistoryPendingActivation,
  LoanStatusHistoryPreActive,
  LoanStatusHistoryActive,
  LoanStatusHistoryArchived,
  LoanStatusHistoryPendingTransfer,
  LoanStatusHistoryTransferred,
  LoanStatusHistoryPaidOff,
  LoanStatusHistoryPaidOffUntracked,
  LoanStatusHistoryReo,
  LoanStatusHistoryLiquidated,
]);
export type LoanStatusHistoryEntry = z.infer<typeof LoanStatusHistoryEntry>;
